import * as React from 'react';
import ContentLayout from 'components/common/layouts/ContentLayout';
import BackOrderContainer from 'containers/backorder/BackOrderConainter';
import { useParams } from 'react-router-dom';
import { GetBackOrderInformationParams } from 'types/member/backorder';

const BackOrder = () => {
  const { groupId } = useParams<GetBackOrderInformationParams>();
  return (
    <ContentLayout pageTitle={'Back Order'}>
      <BackOrderContainer groupId={groupId} />
    </ContentLayout>
  );
};

export default BackOrder;
